import angular from 'angular';
import betaTag from './betaTag';

export default angular
  .module('components.betaTag', [])
  .component('betaTag', betaTag).name;
